import { useEffect, useState } from 'react'

type PersistApi = {
  hasHydrated: () => boolean
  onFinishHydration: (cb: () => void) => () => void
}

/** Wait for a zustand `persist` store to finish reading from storage (avoids empty-state redirects on reload). */
export function useStoreHydration(persistApi: PersistApi): boolean {
  const [hydrated, setHydrated] = useState(() => persistApi.hasHydrated())

  useEffect(() => {
    if (persistApi.hasHydrated()) {
      setHydrated(true)
      return
    }
    return persistApi.onFinishHydration(() => setHydrated(true))
  }, [persistApi])

  return hydrated
}
